import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { flowValidationAtom } from '../../../../Services/_states';
import RenderTextArea from './RenderTextArea.tsx';

interface SuggestionObj {
  label: string;
  value: string;
  paramType?: string;
}

const AddressNode = ({ data }: any) => {
  const flowValidationObj = useRecoilValue(flowValidationAtom);
  const [bodyText, setBodyText] = useState(data?.body || '');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [cursorPosition, setCursorPosition] = useState < number | null > (null);
  const textareaRef = useRef < HTMLTextAreaElement > (null);

  useEffect(() => {
    if (data.body !== bodyText) {
      setBodyText(data.body || '');
    }
  }, [data.body]);

  // Adjust textarea height dynamically
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 12}px`;
    }
  }, [bodyText]);

  // Filter existing labels from bodyText
  const extractedLabels = useMemo(() => {
    return bodyText.match(/{{(.*?)}}/g)?.map((match) => match.replace(/{{|}}/g, "")) || [];
  }, [bodyText]);

  const categorizedParams = useMemo(() => {
    return data?.parentResults?.reduce(
      (acc: { global: string[]; result: string[]; webform: string[] }, result: SuggestionObj) => {
        if (extractedLabels.includes(result.label)) {
          acc[result.paramType as keyof typeof acc]?.push(result.value);
        }
        return acc;
      },
      { global: [], result: [], webform: [] }
    );
  }, [extractedLabels, data?.parentResults]);

  const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setBodyText(value);

    const cursorPos = e.target.selectionStart;
    const match = value.slice(0, cursorPos).match(/{{@(\w*)$/);
    setShowSuggestions(!!match);
    setCursorPosition(match ? cursorPos : null);

    data.onChange(data.id, { body: value, params: categorizedParams });
  };

  const handleSuggestionClick = (suggestion: SuggestionObj) => {
    if (cursorPosition === null) return;

    const updatedText = bodyText.replace(/{{@\w*$/, `{{${suggestion.label}}}`);
    setBodyText(updatedText);
    setShowSuggestions(false);

    const updatedParams = { ...categorizedParams };
    updatedParams[suggestion.paramType as keyof typeof updatedParams]?.push(suggestion.value);

    data.onChange(data.id, { body: updatedText, params: updatedParams });
  };

  return (
    <>
      {/* <label>Body:</label>
      <div style={{ position: 'relative' }}>
        <textarea
          ref={textareaRef}
          value={bodyText}
          onChange={handleBodyChange}
          placeholder="Enter text"
          maxLength={4096}
          style={{
            width: '100%',
            padding: '5px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f5f5f5',
            resize: 'none',
          }}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            bottom: '10px',
            fontSize: '12px',
            color: bodyText.length === 4096 ? 'red' : '#888',
          }}
        >
          {`${bodyText.length}/4096`}
        </span>
      </div>
      {flowValidationObj[data?.id]?.body && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.body}
        </Typography>
      )} */}

      {/* {showSuggestions && data?.parentResults?.length > 0 && (
        <div
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: 4,
            zIndex: 1000,
            width: '100%',
          }}
        >
          {data?.parentResults?.map((suggestion: SuggestionObj, index: number) => (
            <div
              key={suggestion.label}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                padding: '5px 10px',
                cursor: 'pointer',
                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
              }}
            >
              {suggestion.label}
            </div>
          ))}
        </div>
      )} */}
      {/* {showSuggestions && (
        <RenderTextArea
          data={data}
          bodyText={bodyText}
          setBodyText={setBodyText}
          cursorPosition={cursorPosition}
          setCursorPosition={setCursorPosition}
          setShowSuggestions={setShowSuggestions}
          parentResults={data?.parentResults} // Pass parentResults here
        />
      )} */}
      <RenderTextArea
        data={data}
      />
      {flowValidationObj[data?.id]?.body && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.body}
        </Typography>
      )}

    </>
  );
};

export default AddressNode;